// import "babel-polyfill";  //"useBuiltIns": "usage" 时不需要引入

// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.

function checkBrowser ({ messageFunc }) {
  var browserType, browserIEType = '', browserVersion
  var ua = window.navigator.userAgent

  console.log(ua, 'ua', window.navigator.userAgent)

  // test 模拟
  // var ua = 'Mozilla/5.0 (Windows NT 6.3; Trident/7.0; rv 11.0) like Gecko';

  console.log(ua)

  ua = ua.toLocaleLowerCase()

  if (ua.match(/msie/) != null || ua.match(/trident/) != null) {
    browserType = 'IE'

    var isShowClose = false

    if (ua.match(/msie ([\d.]+)/) != null) {
      browserIEType = '11lower'
      browserVersion = ua.match(/msie ([\d.]+)/)

      window.__default_err_msg = '当前浏览器不支持产品部分功能，推荐使用谷歌浏览器'

      isShowClose = false
    } else {
      browserIEType = '11'
      browserVersion = ua.match(/rv:([\d.]+)/)

      isShowClose = true
    }

    if (typeof messageFunc === 'function') {
      try {
        messageFunc({
          type: 'warning',
          dangerouslyUseHTMLString: true,
          message: '您当前浏览器可能无法使用部分功能, 推荐您使用<a target="_blank" rel="nofollow noopener noreferrer" class="chrome_download" href="https://www.google.cn/chrome/" >谷歌浏览器</a>打开',
          customClass: 'manban-toast__warning',
          showClose: isShowClose,
          duration: 0
        })
      } catch (err) {
        alert('您当前浏览器可能无法使用部分功能，推荐您使用谷歌浏览器打开')
      }
    } else {
      alert('您当前浏览器可能无法使用部分功能，推荐您使用谷歌浏览器打开')
    }
  } else if (ua.match(/firefox/) != null) {
    browserType = '火狐'
  } else if (ua.match(/opera/) != null) {
    browserType = '欧朋'
  } else if (ua.match(/chrome/) != null) {
    browserType = '谷歌'
  } else if (ua.match(/safari/) != null) {
    browserType = 'Safari'
  }

  if (ua.match(/MicroMessenger/i) == 'micromessenger' || ua.match(/wxwork/i) == 'wxwork') {
    if (messageFunc && typeof messageFunc === 'function') {
      try {
        messageFunc({
          type: 'warning',
          dangerouslyUseHTMLString: true,
          message: '在微信内打开无法使用部分功能，请复制链接到浏览器中打开！',
          customClass: 'manban-toast__warning',
          showClose: true,
          duration: 0
        })
      } catch (error) {
        alert('在微信内打开无法使用部分功能，请复制链接到浏览器中打开！')
      }
    } else {
      alert('在微信内打开无法使用部分功能，请复制链接到浏览器中打开！')
    }
  }

  console.log('checkBrowser first start', browserType, browserVersion, browserIEType)
  // var arr = new Array(browserType, browserVersion, browserIEType);
  // return arr;
}

import Vue from 'vue'
import VueRouter from 'vue-router'
import App from './App.vue'

// import VueResource from 'vue-resource';

import '@/plugins/vueCookies.js'

import VueGtag from 'vue-gtag'

// import UmyUi from 'umy-ui'
// import 'umy-ui/lib/theme-chalk/index.css';// 引入样式
// Vue.use(UmyUi);

// import VueAnalytics from 'vue-analytics'

// GA初始化
if (process.env.GA) {
  // Vue.use(VueAnalytics, {
  //   id: process.env.GA, // 从配置中读取
  //   disableScriptLoader: true, // 必须在html中完成初始化，这里显式禁止去下载ga脚本
  //   router, // 确保路由切换时可以自动统计
  //   autoTracking: {
  //     pageviewOnLoad: false // 当通过网址进来时已经GA在初始化时就发起一次pageview的统计，这里不要重复统计
  //   }
  // })
  Vue.use(VueGtag, {
    config: {
      id: process.env.GA,
      params: {
        send_page_view: false
      }
    }
  }, router)
}

import ba from 'vue-ba'

// BA初始化
if (process.env.BA) {
  Vue.use(ba, process.env.BA)
  Vue.use(ba, { siteId: process.env.BA })
}

// 公交车
// Vue.prototype.$bus = new Vue()

// 腾讯滑块验证
import TencentCaptcha from '@/plugins/tencentCaptcha'
Vue.use(TencentCaptcha)

import ElementUI from '@/plugins/element-ui-bridge'
import ElementLocale from 'element-ui/lib/locale'
// fade/zoom 等
// import 'element-ui/lib/theme-chalk/base.css';
// collapse 展开折叠
import * as CollapseTransitionModule from 'element-ui/lib/transitions/collapse-transition'
// import '../theme/index.css';

// import 'element-ui/lib/theme-chalk/index.css';
import '@/assets/css/element-variables.scss'
import '@/assets/css/design-system.scss'

const {
  Button,
  Switch,
  Select,
  OptionGroup,
  Autocomplete,
  Input,
  Form,
  FormItem,
  Option,
  DatePicker,
  TimeSelect,
  TimePicker,
  InputNumber,
  Table,
  Tabs,
  TabPane,
  Tag,
  Tree,
  Timeline,
  TimelineItem,
  Link,
  TableColumn,
  Pagination,
  Drawer,
  Dropdown,
  DropdownMenu,
  DropdownItem,
  Menu,
  Submenu,
  MenuItem,
  MenuItemGroup,
  Steps,
  Step,
  Badge,
  Card,
  Slider,
  Tooltip,
  Dialog,
  Container,
  Aside,
  Main,
  Header,
  Upload,
  Progress,
  Loading,
  MessageBox,
  Message,
  Notification,
  Col,
  Image,
  Radio,
  RadioGroup,
  RadioButton,
  Checkbox,
  CheckboxGroup,
  CheckboxButton,
  Collapse,
  CollapseItem,
  Popover,
  Popconfirm,
  InfiniteScroll,
  Empty,
  Skeleton,
  SkeletonItem,
  ColorPicker,
  Row,
  Cascader,
  Rate,
  CascaderPanel
} = ElementUI

const CollapseTransition = CollapseTransitionModule.default || CollapseTransitionModule

// import vuetify from '@/plugins/vuetify';

import VueLazyload from 'vue-lazyload'
import i18n from './lang/index'
Vue.use(VueLazyload)

// with options
Vue.use(VueLazyload, {
  preLoad: 1.3,
  // error: 'dist/error.png',
  // loading: 'dist/loading.gif',
  attempt: 1
})

// import VueTuicalendar from '@lkmadushan/vue-tuicalendar';

// Vue.use(VueTuicalendar);

import moment from 'moment'
import 'moment/locale/zh-cn'
import router from './router'
import store from './store/index'

ElementLocale.i18n((key, value) => i18n.t(key, value))
moment.locale(i18n.locale === 'zh' ? 'zh-cn' : 'en')

// import Vuetify from 'vuetify';

// import reloadDialog from '@/views/reloadDialog/reloadDialog.vue';

Vue.config.productionTip = false

Vue.config.errorHandler = function (err, vm, info) {
  console.log('errorHandle:', err, 'info', info)
  window.__bl && __bl.error(err, { filename: `${vm.$vnode.tag}, ${info}`})
}

Vue.use(VueRouter)
// Vue.use(VueResource);
Vue.use(Button)
Vue.use(Switch)
Vue.use(Select)
Vue.use(OptionGroup)
Vue.use(Autocomplete)
Vue.use(Input)
Vue.use(Form)
Vue.use(FormItem)
Vue.use(Option)
Vue.use(DatePicker)
Vue.use(TimeSelect)
Vue.use(TimePicker)
Vue.use(InputNumber)
Vue.use(Table)
Vue.use(Tabs)
Vue.use(TabPane)
Vue.use(Tag)
Vue.use(Timeline)
Vue.use(TimelineItem)
Vue.use(Tree)
// Timeline,
// TimelineItem,
Vue.use(Link)
Vue.use(TableColumn)
Vue.use(Pagination)
Vue.use(Drawer)
Vue.use(Dropdown)
Vue.use(DropdownMenu)
Vue.use(DropdownItem)
Vue.use(Menu)
Vue.use(Submenu)
Vue.use(MenuItem)
Vue.use(MenuItemGroup)
Vue.use(Steps)
Vue.use(Step)
Vue.use(Badge)
// Badge
Vue.use(Slider)
Vue.use(Card)
Vue.use(Tooltip)
Vue.use(Dialog)
Vue.use(Container)
Vue.use(Aside)
Vue.use(Main)
Vue.use(Header)
Vue.use(Upload)
Vue.use(Progress)
Vue.use(Loading.directive)

Vue.use(Col)
Vue.use(Image)
Vue.use(Radio)
Vue.use(RadioGroup)
Vue.use(RadioButton)
Vue.use(Checkbox)
Vue.use(CheckboxGroup)
Vue.use(CheckboxButton)
Vue.use(Collapse)
Vue.use(CollapseItem)
Vue.use(Popover)
Vue.use(Popconfirm)
Vue.use(InfiniteScroll)
Vue.use(Empty)

Vue.use(Skeleton)
Vue.use(SkeletonItem)

Vue.use(ColorPicker)
Vue.use(Row)
Vue.use(Cascader)
Vue.use(CascaderPanel)
Vue.use(Rate)
Vue.component(CollapseTransition.name, CollapseTransition)
// Vue.use(Vuetify);
// Vue.use(Backtop);

import resize from 'vue-element-resize-detector'
Vue.use(resize)

// 引入基本模板
import * as echarts from 'echarts/core'

// 引入提示框和title组件，图例
import {
  TitleComponent,
  ToolboxComponent,
  TooltipComponent,
  LegendComponent,
  GridComponent,
  GraphicComponent
} from 'echarts/components'

// 引入折线图等组件
import {
  LineChart,
  BarChart,
  RadarChart,
  PieChart,
  FunnelChart
} from 'echarts/charts'
import {
  CanvasRenderer
} from 'echarts/renderers'

echarts.use(
  [
    TitleComponent,
    ToolboxComponent,
    TooltipComponent,
    LegendComponent,
    GridComponent,

    FunnelChart,
    LineChart,
    BarChart,
    RadarChart,
    PieChart,

    CanvasRenderer,
    GraphicComponent
  ]
)

// //引入基本模板
// let echarts = require('echarts/lib/echarts')

// 引入折线图等组件
// require('echarts/lib/chart/line')
// require('echarts/lib/chart/bar')
// require('echarts/lib/chart/radar')
// require('echarts/lib/chart/pie')
// require('echarts/lib/chart/funnel')

// 引入提示框和title组件，图例
// require('echarts/lib/component/tooltip')
// require('echarts/lib/component/title')
// require('echarts/lib/component/legend')
// require('echarts/lib/component/legendScroll')//图例翻译滚动

// require('echarts/lib/component/dataZoom')
// require('echarts/lib/component/dataZoomInside')
// require('echarts/lib/component/dataZoomSelect')
// require('echarts/lib/component/dataZoomSlider') //横坐标数据过多横向滚动

Vue.prototype.$echarts = echarts

Vue.prototype.$loading = Loading.service
Vue.prototype.$msgbox = MessageBox
Vue.prototype.$alert = MessageBox.alert
Vue.prototype.$confirm = MessageBox.confirm
Vue.prototype.$prompt = MessageBox.prompt
Vue.prototype.$notify = Notification
Vue.prototype.$message = Message
Vue.prototype.$moment = moment

// 引入mathjs用来解决js计算不准确的问题
import * as math from 'mathjs'
Vue.prototype.$math = math
// 全局积分名
Vue.prototype.$point_name = '积分'
/* eslint-disable no-new */

// window.__setTokenExpire = function (target = window, token, expire) {
//   const host = window.location.host

//   console.log(host, 'host')

//   const defaultOptions = ['/', host, '', 'Lax']

//   target.$cookies.config('1d', '/', host, '', 'Lax')
//   // set: function (key, value, expireTimes, path, domain, secure, sameSite)

//   target.$cookies.set('token', token, expire, ...defaultOptions)
// }

// window.myapp=
Vue.prototype.$tt = function (chinese = '', english = '') {
  return this.$t('options.option', { label: this.$i18n.locale === 'zh' ? chinese : english })
}

Vue.prototype.$ttt = function ({ label, labelEN }) {
  return this.$tt(label, labelEN)
}
window.myapp = new Vue({
  // el: '#app',
  data () {
    return {
      eventBus: new Vue()
    }
  },
  // vuetify,
  // vuetify: new Vuetify(),
  router,
  i18n,
  store,

  render: (h) => h(App),
  components: {
    App
    // reloadDialog
  }
}).$mount('#app')

checkBrowser({ messageFunc: window.myapp.$message })

// import { redirectRightPageAfterLogin } from '@/tools/async-tool.js';

// 全局路由守卫
router.beforeEach((to, from, next) => {
  if (to.meta.requiresAuth && to.matched.some(record => record.meta.requiresAuth)) {
    if (store.getters.lock_errors.includes('req_login_fail')) {
      // store.dispatch('other/delLockErrorMsg', 'req_login_fail');
      next()
      return false
    } else {
      // store.dispatch('other/addLockErrorMsg', 'req_login_fail');
      if (!Vue.prototype.$cookies.isKey('token')) {
        window.myapp.$message({
          type: 'error',
          message: '登录失效，请重新登录',
          customClass: 'manban-toast__error',
          onClose: () => {
            // store.dispatch('other/delLockErrorMsg', 'req_login_fail');
          }
        })
        // store.dispatch('other/delLockErrorMsg', 'req_login_fail');
        // setTimeout(() => {
        //   store.dispatch('other/delLockErrorMsg', 'req_login_fail');
        // }, 3000)

        // redirectRightPageAfterLogin(router, 'login')
      }
    }
    // !Vue.prototype.$cookies.isKey('token') && window.myapp.$message({
    //   type: 'error',
    //   message: '登录失效，请重新登录!'
    // });
  }
  // const cur_org = store.getters.cur_org || {}

  // console.log(cur_org, 'cur_org')

  // if (!cur_org.id) { // 机构信息丢失
  //   store.dispatch('org/getOrgDetail');
  // }
  next()
})

// vue-router并且使用路由懒加载的情况下，我们访问当前应用进行路由跳转时都是实时动态的从服务器上拉取相应模块的js文件，这时候我们改完代码打包上线，js文件名更换了，路由跳转的时候由于页面并未刷新，所以还是访问的原来的文件名，这是就会出现找不到模块的错误
router.onError((error) => {
  console.log(error, 'router.onError')

  const pattern = /Loading chunk (\d)+ failed/g
  const isChunkLoadFailed = error.message && error.message.match(pattern)
  if (isChunkLoadFailed) {
    // window.location.reload(true);

    window.location.href = window.location.href
    // router.replace(router.history.pending.fullPath);
  } else {
    console.log(error)
  }
})

window.addEventListener('unhandledrejection', e => {
  throw e.reason
})
window.addEventListener('error', args => {
  console.log(
    'error event:', args
  )
  return true
}, true)

import { v4 as uuidv4 } from 'uuid'
let userUid = localStorage.getItem('uuid')
if (!userUid) {
  userUid = uuidv4()
  localStorage.setItem('uuid', userUid)
}
if (window.__bl && typeof window.__bl.setConfig === 'function') {
  window.__bl.setConfig({
    uid: userUid,
    ignore: {
      ignoreErrors: [
        'cancel',
        /^Script error\.?$/
      ]
    }
  })
}
